module.exports = __webpack_public_path__ + "img/spinner.36d3e1e2.gif";